import React, { useEffect, useRef, useState } from 'react'
import { Box } from '@mui/material'
import "../Assets/Style/BigRoundTextLogo.css";
import AppLogo from "../Assets/Images/BigLogoIcon.png";
import DarkAppLogo from "../Assets/Images/BigDarkLogoIcon.png";
import { useAppContext } from '../context/useAppContext';

function AutoRoundedAppLogo() {
    const text = "App Gallery • Building Intelligent Systems • ";
    const containerRef = useRef(null);
    const textRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
    const { darkTheme} = useAppContext();

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting);
            },
            { threshold: 0.3 }
        );

        if (containerRef.current) {
            observer.observe(containerRef.current);
        }

        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        let animationFrame;
        let rotation = 0;

        const rotate = () => {
            if (isVisible && textRef.current) {
                rotation += 0.1; // speed control (increase for faster)
                textRef.current.style.transform = `rotate(${rotation}deg)`;
            }
            animationFrame = requestAnimationFrame(rotate);
        };

        rotate();

        return () => cancelAnimationFrame(animationFrame);
    }, [isVisible]);
    return (
        <Box display={{ xs: 'none', md: 'flex' }} className="Big-logo-container" ref={containerRef}>
            <div className="circle-text2 text-color-main" ref={textRef}>
                {text.split("").map((char, index) => (
                    <span
                        key={index}
                        className="text-color-main"
                        style={{
                            transform: `rotate(${index * (360 / text.length)}deg)`,
                        }}
                    >
                        {char}
                    </span>
                ))}
            </div>

            <img src={darkTheme ? DarkAppLogo :AppLogo} alt="center-arrow" className="center-image2" />
        </Box>
    )
}

export default AutoRoundedAppLogo
